import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DatiPignoramento } from 'src/app/common/models/dati-pignoramento/dati-pignoramento';
import { SezioneDatiPignoramento } from 'src/app/common/models/sezioni/sezione-dati-pignoramento';
import { DatiPignoramentoUpdateComponent } from './dati-pignoramento-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [dati-pignoramento-mod-update]',
  templateUrl: 'dati-pignoramento-mod-update.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class DatiPignoramentoModUpdate {
  @ViewChild('formUpdate') formUpdate: DatiPignoramentoUpdateComponent;

  @Output()
  onReturn: EventEmitter<SezioneDatiPignoramento> = new EventEmitter<SezioneDatiPignoramento>();

  inizializza(datiPignoramento: DatiPignoramento, urlUpdateBene: string, idSezione: string) {
    this.formUpdate.inizializza(datiPignoramento, urlUpdateBene, idSezione);
    openModal('modalupdateDatiPignoramento');
  }

  createForm() {
    this.formUpdate.createForm();
  }

  manageModal(sezione: SezioneDatiPignoramento) {
    closeModal('modalupdateDatiPignoramento');
    this.onReturn.emit(sezione);
  }
}
